import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { MessagesApiService } from './messages-api.service';
import { MessagesEffects } from './messages.effects';
import {
  MESSAGES_STORE_KEY,
  messagesInitialState,
  messagesReducer
} from './messages.reducer';

export const metaReducers: MetaReducer<any>[] = [localStorageSyncReducer];

@NgModule({
  imports: [
    StoreModule.forFeature(MESSAGES_STORE_KEY, messagesReducer, {
      metaReducers,
      initialState: messagesInitialState
    }),
    EffectsModule.forFeature([MessagesEffects])
  ],
  providers: [MessagesApiService]
})
export class MessagesStoreModule {}

// TODO :: remove when finished
export function localStorageSyncReducer(
  reducer: ActionReducer<any>
): ActionReducer<any> {
  return localStorageSync({
    keys: ['selectedDiscussionUuid'],
    rehydrate: true,
    removeOnUndefined: true
  })(reducer);
}
